import React, { useEffect, useState } from "react";
import firebase from "../../../firebase";
import "./blogPost.scss";
import { Button, Card, Modal, Form, Alert } from "react-bootstrap";
import PictureAsPdfIcon from "@material-ui/icons/PictureAsPdf";
import Menu from "@material-ui/icons/PictureAsPdf";

export const SignupForm = (props) => {
  const [loader, setLoader] = useState(false);

  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  // const [pdfUrl, setPdfUrl] = useState("");
  // const serverResponse = {
  //   pdfUrl: "http://example.com/path/to/your/generated/pdf.pdf",
  // };
  const pdfUrls = "https://www.cloudsocial.io/wp-content/uploads/2023/The%20Ultimate%20Instagram%20Marketing%20Guide-For%20Beginners%20in%202023.pdf";

  const handlePdfOpen = () => {
    // Open the PDF in a new tab.
    window.open(pdfUrls, "_blank");
    setShow(false);
  };
  const handleShow = () => {
    setShow(true);
  };

  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phoneNumber: "",
    // Other form fields
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
      createdAt: new Date(),
    });
  };

  const validateForm = () => {
    const newErrors = {};
    // Add validation rules here
    if (!formData.name) {
      newErrors.name = "Name is required";
    }

    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/^\S+@\S+\.\S+$/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!formData.phoneNumber) {
      newErrors.phoneNumber = "Phone number is required";
    } else if (!/^[0-9]{10}$/.test(formData.phoneNumber)) {
      newErrors.phoneNumber = "Invalid phone number format";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      firebase
        .collection("blogForm")
        .add(formData)
        .then(() => {
          console.log("Form submitted successfully!");
          handlePdfOpen();
          setFormData({
            name:"",
            email: "",
            phoneNumber: ""
          });
          // setPdfUrl(serverResponse.pdfUrl);
        })
        .catch((error) => {
          console.error("Error submitting form:", error);
        });
    }
  };

  useEffect(() => { }, []);
  return (
    <div style={{ marginTop: "10px" }}>
      <Card className="recentCard">
        <Card className="recentBlogCard">
          <Card.Body style={{ padding: "0px" }}>
            <Card.Title className="recentBlogTitle">The Ultimate Instagram Marketing Guide-For Beginners in 2023</Card.Title>
            <Card.Footer>
              {/* <Button className="login" onClick={handleShow}>
              Get E-book
              <Menu />
              </Button> */}
              <Button
                onClick={handleShow}
                target="_blank"
                size="small"
                color="primary"
              >
                Get E-book &nbsp;
                <Menu />
              </Button>
            </Card.Footer>
          </Card.Body>
        </Card>
        <Modal
          size="md"
          show={show}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          centered
        >
          <Modal.Header className="modelHeader" closeButton>
            Form
          </Modal.Header>
          <Modal.Body className="model-body" style={{ padding: "10px" }}>
            <Form onSubmit={handleSubmit}>
              <Form.Group controlId="name">
                <Form.Label>Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  isInvalid={!!errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.name}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group controlId="email">
                <Form.Label>Email</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  isInvalid={!!errors.email}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.email}
                </Form.Control.Feedback>
              </Form.Group>
              <Form.Group controlId="phoneNumber">
                <Form.Label>Phone Number</Form.Label>
                <Form.Control
                  type="tel" // Use "tel" type for phone numbers to provide mobile-specific input features
                  name="phoneNumber"
                  value={formData.phoneNumber}
                  onChange={handleChange}
                  isInvalid={!!errors.phoneNumber}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.phoneNumber}
                </Form.Control.Feedback>
              </Form.Group>
              <div style={{ textAlign: "end" }}>
                <Button type="submit" className="login">
                  Submit
                </Button>
                {/* <Button onClick={handlePdfOpen}>Open PDF in New Tab</Button>
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<PictureAsPdfIcon />}
                  onClick={handlePdfOpen}
                >
                  Open PDF
                </Button> */}
              </div>
              {/* {pdfUrl && ( */}
              {/* <div className="dataLogin">
                <a
                  href={pdfUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="login"
                >
                  <Button className="login" style={{ boxShadow: "none" }}>
                    Open Doc
                  </Button>
                </a>
              </div> */}
              {/* )} */}
            </Form>
          </Modal.Body>
        </Modal>
      </Card>
    </div>
  );
};
